// ============================================
// FILE: src/pages/InquiryPage.jsx
// ============================================
import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const InquiryPage = () => {
  const [hoveredSocial, setHoveredSocial] = useState(null);

  const contactInfo = [
    {
      icon: <Phone size={20} />,
      label: 'Phone Numbers',
      value: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <a 
            href="tel:+919764646044" 
            className="phone-link"
            onClick={(e) => e.stopPropagation()}
            style={{ 
              color: '#1A1A2E', 
              textDecoration: 'none',
              fontWeight: 500,
              transition: 'color 0.15s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#1A3A8F'}
            onMouseLeave={(e) => e.target.style.color = '#1A1A2E'}
          >
            +91 97646 46044
          </a>
          <a 
            href="tel:+919158636044" 
            className="phone-link"
            onClick={(e) => e.stopPropagation()}
            style={{ 
              color: '#1A1A2E', 
              textDecoration: 'none',
              fontWeight: 500,
              transition: 'color 0.15s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#1A3A8F'}
            onMouseLeave={(e) => e.target.style.color = '#1A1A2E'}
          >
            +91 91586 36044
          </a>
        </div>
      ),
      href: null,
    },
    {
      icon: <Mail size={20} />,
      label: 'Email Address',
      value: 'saipropertiesandfinance@gmail.com',
      href: 'mailto:saipropertiesandfinance@gmail.com',
    },
    {
      icon: <MapPin size={20} />,
      label: 'Office Address',
      value: 'Survey No 298, Nirvana Lifecity, Office No. B-12, opposite Kohinoor Viva City, Lohegaon, Pune, Maharashtra 411047',
      href: 'https://maps.google.com/?q=Survey+No+298+Nirvana+Lifecity+Office+No+B-12+opposite+Kohinoor+Viva+City+Lohegaon+Pune+Maharashtra+411047',
    },
    {
      icon: <Clock size={20} />,
      label: 'Working Hours',
      value: 'Mon – Sat: 10:00 AM to 8:00 PM',
      href: null,
    },
  ];

  // SVG Social Icons Components
  const FacebookIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );

  const InstagramIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" 
        stroke={color} 
        strokeWidth="1.5" 
        fill="none"
      />
      <circle cx="12" cy="12" r="4" 
        stroke={color} 
        strokeWidth="1.5" 
        fill="none"
      />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );

  const YoutubeIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );

  const socialLinks = [
    {
      id: 'facebook',
      icon: <FacebookIcon size={18} />,
      label: 'Facebook',
      href: 'https://www.facebook.com/shreesaip/',
      color: '#1877F2',
      bg: '#E7F0FD',
    },
    {
      id: 'instagram',
      icon: <InstagramIcon size={18} />,
      label: 'Instagram',
      href: 'https://www.instagram.com/shreesaiproperties/',
      color: '#E1306C',
      bg: '#FDEAF1',
    },
    {
      id: 'youtube',
      icon: <YoutubeIcon size={18} />,
      label: 'YouTube',
      href: 'https://www.youtube.com/@shreesaiproperties1198',
      color: '#FF0000',
      bg: '#FEEBEB',
    },
  ];

  return (
    <div style={{ background: '#F7F8FC', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@400;500;600&display=swap');

        .inquiry-page * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        .inquiry-page {
          font-family: 'DM Sans', sans-serif;
          color: #1A1A2E;
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
        }

        /* Main Content - Centered */
        .main-content {
          max-width: 1100px;
          margin: 40px auto;
          padding: 0 24px 80px;
          position: relative;
          z-index: 10;
        }

        /* Grid Layout - Single column since form is removed */
        .contact-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 24px;
          align-items: start;
          max-width: 600px;
          margin: 0 auto;
        }

        /* Contact Card */
        .contact-card {
          background: #FFFFFF;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 4px 24px rgba(15, 27, 76, 0.08);
          border: 1px solid #E8EBF4;
          height: auto;
        }

        .contact-card-header {
          background: linear-gradient(135deg, #0F1B4C 0%, #1A3A8F 100%);
          padding: 28px 28px 24px;
        }

        .contact-card-header h2 {
          font-family: 'DM Serif Display', serif;
          font-size: 22px;
          color: #FFFFFF;
          margin-bottom: 4px;
        }

        .contact-card-header p {
          font-size: 13px;
          color: #93C5FD;
        }

        .contact-card-body {
          padding: 8px 0;
        }

        /* Contact Item */
        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          padding: 16px 24px;
          text-decoration: none;
          color: inherit;
          border-bottom: 1px solid #F0F2FA;
          transition: background 0.15s ease;
          cursor: pointer;
        }

        .contact-item:last-child {
          border-bottom: none;
        }

        .contact-item:hover {
          background: #F7F8FC;
        }

        .contact-icon-wrap {
          width: 40px;
          height: 40px;
          background: #EEF2FF;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1A3A8F;
          flex-shrink: 0;
        }

        .contact-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #6B7A99;
          margin-bottom: 3px;
        }

        .contact-value {
          font-size: 14px;
          font-weight: 500;
          color: #1A1A2E;
          line-height: 1.4;
        }

        .contact-item:hover .contact-value {
          color: #1A3A8F;
        }

        .phone-link {
          display: inline-block;
          transition: color 0.15s ease;
        }

        .phone-link:hover {
          color: #1A3A8F !important;
          text-decoration: underline;
        }

        /* Social Section */
        .social-section {
          padding: 20px 24px 24px;
          border-top: 1px solid #F0F2FA;
        }

        .social-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #6B7A99;
          margin-bottom: 12px;
        }

        .social-links {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .social-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 14px;
          border-radius: 10px;
          text-decoration: none;
          font-size: 13px;
          font-weight: 500;
          border: 1.5px solid transparent;
          transition: all 0.2s ease;
          cursor: pointer;
        }

        .social-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        /* Map Section */
        .map-section {
          margin-top: 32px;
          background: #FFFFFF;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 4px 24px rgba(15, 27, 76, 0.08);
          border: 1px solid #E8EBF4;
        }

        .map-header {
          padding: 20px 28px 16px;
          border-bottom: 1px solid #F0F2FA;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .map-header-icon {
          width: 36px;
          height: 36px;
          background: #EEF2FF;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1A3A8F;
        }

        .map-header h2 {
          font-family: 'DM Serif Display', serif;
          font-size: 18px;
          color: #1A1A2E;
        }

        .map-header p {
          font-size: 13px;
          color: #6B7A99;
        }

        .map-embed {
          height: 300px;
          position: relative;
        }

        .map-embed iframe {
          width: 100%;
          height: 100%;
          border: 0;
          display: block;
        }

        /* Trust badge strip */
        .trust-strip {
          display: flex;
          justify-content: center;
          gap: 32px;
          padding: 28px 24px;
          background: #FFFFFF;
          border-radius: 16px;
          margin-bottom: 28px;
          box-shadow: 0 2px 12px rgba(15, 27, 76, 0.05);
          border: 1px solid #E8EBF4;
          flex-wrap: wrap;
        }

        .trust-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          font-weight: 500;
          color: #6B7A99;
        }

        .trust-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #22C55E;
          flex-shrink: 0;
        }

        @media (max-width: 768px) {
          .contact-grid {
            max-width: 100%;
          }
        }
      `}</style>

      <div className="inquiry-page">
        {/* Main Content */}
        <div className="main-content">

          {/* Trust Strip - Commented out */}
          {/* <div className="trust-strip">
            {['15+ Years Experience', '2,400+ Properties Sold', 'RERA Registered', 'Free Consultation'].map((item) => (
              <div key={item} className="trust-item">
                <span className="trust-dot" />
                {item}
              </div>
            ))}
          </div> */}

          {/* Grid - Single Column Contact Info */}
          <div className="contact-grid">

            {/* Contact Info Card */}
            <div className="contact-card">
              <div className="contact-card-header">
                <h2>Contact Information</h2>
                <p>Reach us through any of these channels</p>
              </div>

              <div className="contact-card-body">
                {contactInfo.map((item, i) => {
                  const Tag = item.href ? 'a' : 'div';
                  return (
                    <Tag
                      key={i}
                      href={item.href}
                      className="contact-item"
                      target={item.href?.startsWith('http') ? '_blank' : undefined}
                      rel={item.href?.startsWith('http') ? 'noopener noreferrer' : undefined}
                    >
                      <div className="contact-icon-wrap">
                        {item.icon}
                      </div>
                      <div>
                        <div className="contact-label">{item.label}</div>
                        <div className="contact-value">{item.value}</div>
                      </div>
                    </Tag>
                  );
                })}
              </div>

              {/* Social */}
              <div className="social-section">
                <div className="social-label">Follow us</div>
                <div className="social-links">
                  {socialLinks.map((s) => (
                    <a
                      key={s.id}
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-btn"
                      aria-label={s.label}
                      style={{
                        background: hoveredSocial === s.id ? s.bg : '#F7F8FC',
                        color: hoveredSocial === s.id ? s.color : '#6B7A99',
                        borderColor: hoveredSocial === s.id ? s.color + '40' : '#E8EBF4',
                      }}
                      onMouseEnter={() => setHoveredSocial(s.id)}
                      onMouseLeave={() => setHoveredSocial(null)}
                    >
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        {s.icon}
                      </span>
                      <span>{s.label}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="map-section">
            <div className="map-header">
              <div className="map-header-icon">
                <MapPin size={18} />
              </div>
              <div>
                <h2>Find Our Office</h2>
                <p>Lohegaon, Pune — Maharashtra 411047</p>
              </div>
            </div>
            <div className="map-embed">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.094507392825!2d73.9150165!3d18.571526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c15b6a4a4a4b%3A0x4a4a4a4a4a4a4a4a!2sLohegaon%2C%20Pune%2C%20Maharashtra%20411047!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                allowFullScreen
                loading="lazy"
                title="Office Location Map - Lohegaon, Pune"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default InquiryPage;